import React from "react";
import {cn} from "@/lib/utils";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    progress: number;
}

export default function ProgressBar({progress, className, ...props}: IProps) {
    return (
        <div
            className={cn('h-[4px] rounded-[2px] w-full bg-white-transparent-20  overflow-hidden transition-transform duration-200', className)} {...props}>
            <div className={'h-full w-full bg-orange-main'} style={{width: `${progress}%`}}></div>
        </div>
    )
}
